import './theme.css'

import { QueryClient, VueQueryPlugin } from '@tanstack/vue-query'
import { createApp } from 'vue'

import App from '@/App.vue'
import { onSignedOut } from '@/lib/api'
import { router } from '@/router'

const queryClient = new QueryClient({ defaultOptions: { queries: { retry: 1, staleTime: 5 * 60_000 } } })
// Cached data belongs to one session: drop it on sign-out.
onSignedOut.push(() => queryClient.clear())

createApp(App).use(router).use(VueQueryPlugin, { queryClient }).mount('#root')
